<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-departamento") }} <small>({{ total }} registros)</small>
        </el-col>
        <el-col :offset="8" :lg="8">
          <el-pagination
            class="right"
            :page-size="filter.records"
            background
            @current-change="fetchRecords"
            @size-change="changeSize"
            :current-page.sync="filter.page"
            layout="sizes, prev, pager, next"
            :page-sizes="[
              50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
            ]"
            :total="total"
          ></el-pagination>
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter.word"
            v-on:keyup.native.enter="fetchRecords()" 
          >
          <el-button slot="append" @click="fetchRecords" icon="el-icon-search"></el-button>
        </el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="customer"
          :label="user.type === '2' ? $t('filial') : $t('cliente')"
          v-if="user.type !== '5'"
        >
          <template slot-scope="scope">
            {{ scope.row.customer }}
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="code"
          :label="$t('codigo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome')"
        ></el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="8">
            <el-pagination
              :page-size="filter.records"
              background
              @current-change="fetchRecords"
              :current-page.sync="filter.page"
              layout="prev, pager, next"
              :total="total"
              v-show="total > filter.records"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import { DepartmentService } from "@/services/department/department.services";
import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "Department",
  methods: {
    changeSize(size) {
      const vm = this;
      vm.filter.records = size;
      vm.fetchRecords();
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      DepartmentService.list(vm.filter.records, vm.filter.page, vm.filter.word, 2)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({
        name: "department.add",
      });
    },
    editar: function (id) {
      this.$router.replace({
        name: "department.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-departamento", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        DepartmentService.delete(id)
          .then((response) => {
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id == id),
              1
            );
            this.$message({
              type: "success",
              message: i18n.tc("departamento-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: {
        records: 50,
        page: 1,
        word: "",
      },
      total: 0,
      tableData: [],
      user: { type: "2" },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>